import { CoreInfoRequestDetailCreate } from "./CoreInfoRequestDetailModel";

export class CoreInfoRequestPostModel {
  public RequestId?: number;
  public Remark?: string;
  public Tso?: number;
  public Cso?: number;
  public Dso?: number;
  public Tsr?: number;
  public Csr?: number;
  public Dsr?: number;
  public Tsn?: number;
  public Csn?: number;
  public Dsn?: number;
  public Tsi?: number;
  public Csi?: number;
  public Dsi?: number;
  public RemovalReasonDetail?: string;
  public AdSbMod?: string;
  public Dom?: string;
  public Nla?: string;
  public Nha?: string;
  public EngineSerialNumber?: string;
  public RequestedFields?: string;
  public Status?: number;
  public AccomplishDate?: Date;
  public RespondedDate?: Date;
  public CoreInfoRequestDetails?: CoreInfoRequestDetailCreate[];
}

export class CoreInfoRequestPutModel {
  public Id?: number;
  public RequestId?: number;
  public Remark?: string;
  public Tso?: number;
  public Cso?: number;
  public Dso?: number;
  public Tsr?: number;
  public Csr?: number;
  public Dsr?: number;
  public Tsn?: number;
  public Csn?: number;
  public Dsn?: number;
  public Tsi?: number;
  public Csi?: number;
  public Dsi?: number;
  public RemovalReasonDetail?: string;
  public AdSbMod?: string;
  public Dom?: string;
  public Nla?: string;
  public Nha?: string;
  public EngineSerialNumber?: string;
  public RequestedFields?: string;
  public IsCustomerUpdate?: boolean;
  public IsStatusUpdate?: boolean;
  public Status?: number;
  public AccomplishDate?: Date;
  public RespondedDate?: Date;
  public CoreInfoRequestDetails?: CoreInfoRequestDetailCreate[];
}
